module.exports = "<div class=\"preloader-wrapper active  {{spinnerType}}\">\r\n    <mdb-Spinners mdbSpinners mode=\"indeterminate\"></mdb-Spinners>\r\n</div>"